/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import * as RadixSwitch from '@radix-ui/react-switch'
import React from 'react'

import { cn } from '@/utils/css'

/** A description of the available properties for this component. */
type SwitchProps = {
  /** Whether the toggle is enabled or not. */
  enabled: boolean

  /** The label for the toggle. */
  label: string

  /** The function to call when the toggle is changed. */
  onChange?: (enabled: boolean) => void

  /** The description for the toggle. */
  description?: string

  /** Whether the toggle is disabled. */
  disabled?: boolean
}

/**
 * A controlled toggle component with a label and description.
 */
const Switch: React.FC<SwitchProps> = ({ enabled, onChange, label, description, disabled = false }) => {
  return (
    <div className={'flex flex-row items-center justify-between gap-2'}>
      <div className={'flex flex-col'}>
        {label && <label className={'text-base font-semibold text-graphite-500'}>{label}</label>}
        {description && <span className={'font-light text-base text-graphite-500'}>{description}</span>}
      </div>
      <RadixSwitch.Root
        disabled={disabled}
        checked={enabled}
        onCheckedChange={onChange}
        className={cn(
          'h-6 w-11 min-w-11 rounded-full relative',
          'bg-primary-500 data-[state=unchecked]:bg-gray-400 transition-colors',
          'data-disabled:bg-primary-100 data-disabled:cursor-not-allowed',
        )}
      >
        <RadixSwitch.Thumb
          className={cn(
            'bg-white h-5 w-5 rounded-full block',
            'transition-transform translate-x-0.5 data-[state=checked]:translate-x-[22px]',
          )}
        />
      </RadixSwitch.Root>
    </div>
  )
}

export { Switch }
